import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsPanel = ({ metrics }) => {
  const metricCards = [
    {
      title: 'Today\'s Consultations',
      value: metrics?.todayConsultations,
      change: metrics?.consultationChange,
      icon: 'Video',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Pending Tasks',
      value: metrics?.pendingTasks,
      change: metrics?.taskChange,
      icon: 'CheckSquare',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      title: 'Safety Incidents',
      value: metrics?.safetyIncidents,
      change: metrics?.incidentChange,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      title: 'Patient Satisfaction',
      value: `${metrics?.patientSatisfaction}%`,
      change: metrics?.satisfactionChange,
      icon: 'Heart',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  const getChangeColor = (change) => {
    if (change > 0) return 'text-success';
    if (change < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = (change) => {
    if (change > 0) return 'TrendingUp';
    if (change < 0) return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metricCards?.map((metric) => (
        <div key={metric?.title} className="bg-card rounded-lg border border-border p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
            <div className={`flex items-center space-x-1 ${getChangeColor(metric?.change)}`}>
              <Icon name={getChangeIcon(metric?.change)} size={16} />
              <span className="text-sm font-medium">
                {Math.abs(metric?.change)}%
              </span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{metric?.value}</h3>
            <p className="text-sm text-muted-foreground">{metric?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;